import clsx from 'clsx';

import styles from './Sidebar.module.scss';

export enum DesignSystemSidebarDensity {
  COMPACT = 'compact',
  COMFORTABLE = 'comfortable',
}

type GetSidebarShellClassesOptions = {
  density?: DesignSystemSidebarDensity;
  className?: string;
};

type GetSidebarItemClassesOptions = {
  isActive?: boolean;
  isDisabled?: boolean;
  isCollapsed?: boolean;
  className?: string;
};

const sidebarShellSurfaceByDensity: Record<DesignSystemSidebarDensity, string> =
  {
    [DesignSystemSidebarDensity.COMPACT]: styles.desktop,
    [DesignSystemSidebarDensity.COMFORTABLE]: styles.mobile,
  };

export const getSidebarShellClasses = ({
  density = DesignSystemSidebarDensity.COMPACT,
  className,
}: GetSidebarShellClassesOptions): string => {
  return clsx(
    styles.shell,
    styles[density],
    sidebarShellSurfaceByDensity[density],
    className,
  );
};

export const getSidebarItemClasses = ({
  isActive,
  isDisabled,
  isCollapsed,
  className,
}: GetSidebarItemClassesOptions): string => {
  return clsx(
    styles.item,
    {
      [styles.is_active]: isActive,
      [styles.is_disabled]: isDisabled,
      [styles.is_collapsed]: isCollapsed,
    },
    className,
  );
};
